import { useId } from 'react';
import { Input } from '@monksflow/monks-ui';
import { TypeIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { KnowledgeBaseFormFieldV2 } from './KnowledgeBaseFormFieldV2';
import type { KnowledgeBaseFormTitleProps } from '../KnowledgeBaseFormTitle/KnowledgeBaseFormTitle.types';

export const TITLE_MAX_LENGTH = 50;

/**
 * Tessra twin of `KnowledgeBaseFormTitle`. Same props, so the two are
 * interchangeable at the call site.
 */
export const KnowledgeBaseFormTitleV2 = ({
  title,
  setTitle,
  error,
}: KnowledgeBaseFormTitleProps) => {
  const { t } = useTranslation('knowledge');

  const fieldId = useId();
  const helpId = useId();
  const errorId = useId();

  return (
    <KnowledgeBaseFormFieldV2
      icon={TypeIcon}
      title={t('knowledgeBases.knowledgeBaseFormTitle.title')}
      description={t('knowledgeBases.knowledgeBaseFormTitle.giveAShortAndClear')}
      required
      fieldId={fieldId}
      descriptionId={helpId}
    >
      <div className="flex flex-col gap-2xs">
        <Input
          id={fieldId}
          value={title}
          maxLength={TITLE_MAX_LENGTH}
          required
          aria-invalid={!!error}
          aria-describedby={error ? `${helpId} ${errorId}` : helpId}
          placeholder={t('knowledgeBases.knowledgeBaseFormTitle.eGBrandIdentity')}
          onChange={(event) => setTitle(event.target.value)}
        />
        <span
          id={error ? errorId : undefined}
          role={error ? 'alert' : undefined}
          className={`type-body-sm ${error ? 'text-destructive' : 'text-muted-foreground'}`}
        >
          {error || `${title.length}/${TITLE_MAX_LENGTH}`}
        </span>
      </div>
    </KnowledgeBaseFormFieldV2>
  );
};

KnowledgeBaseFormTitleV2.displayName = 'KnowledgeBaseFormTitleV2';
